// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1OhOg","content":"LoadingAlert_content__1N2jE"};